import React from 'react';
import './RecognitionCard.scss';
import GlobalButton from '@/components/Button/button';

interface RecognitionCardProps {
  badgeImage?: string;
  badgeImageAlt?: string;
  badgeMedia?: React.ReactNode;
  title: string;
  description: string;
  learnMoreLink?: string;
}

const RecognitionCard: React.FC<RecognitionCardProps> = ({
  badgeImage,
  badgeImageAlt = 'Recognition Badge',
  title,
  description,
  learnMoreLink,
}) => {
  return (
    <div className="recognition-card">
      <div className="recognition-card-image">
        <a href={learnMoreLink} target="_blank" rel="noopener">
          <img decoding="async" src={badgeImage} alt={badgeImageAlt} style={{ border: 0 }} />
        </a>
      </div>
      <div className="recognition-card-content">
        <div style={{ flex: 1 }}>
          <div>
            <p>
              <span className="strong">{title}</span>
              <br />
            </p>
          </div>
          <div className="card-content-holder">
            {description}
            <p></p>
          </div>
        </div>
        {learnMoreLink && (
          <div style={{ marginTop: 'auto' }}>
            <GlobalButton
              color="ghost"
              icon="ArrowRight"
              text="Learn more"
              href={learnMoreLink}
              target="_blank"
              style={{ paddingLeft: 0 }}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default RecognitionCard;
